import { useEffect } from 'react'
import { useLibrary } from '../contexts/LibraryContext'
import { defaultPlaylistSeeds } from '../data/seeds'
import { searchTracks } from '../utils/itunes'
import { readStore, writeStore } from '../utils/storage'

/**
 * First visit only: stock the library with a few real, randomised sets so the
 * playlist surfaces aren't empty. Editable and deletable like any other set,
 * and never re-created once the user has been seeded.
 */
export function useSeedPlaylists(): void {
  const { playlists, createPlaylist } = useLibrary()

  useEffect(() => {
    if (readStore<boolean>('playlistsSeeded', false)) return
    if (playlists.length > 0) {
      writeStore('playlistsSeeded', true)
      return
    }
    writeStore('playlistsSeeded', true)
    let cancelled = false

    void (async () => {
      for (const seed of defaultPlaylistSeeds) {
        try {
          const found = await searchTracks(seed.term, 25)
          if (cancelled || found.length === 0) continue
          const picks = [...found].sort(() => Math.random() - 0.5).slice(0, 8)
          createPlaylist(seed.name, picks, seed.note)
        } catch {
          /* offline on first load — the user can still build sets by hand */
        }
      }
    })()

    return () => {
      cancelled = true
    }
    // Intentionally runs once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
